/**
 * Tolerantly unwrap list responses where the backend sometimes returns
 * a bare array and sometimes returns { <key>: [...] }.
 */
export function unwrap(data, key) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  return [];
}
